import { getNetwork } from '../../utils/getNetwork';
import { API_ROOT } from '../../config';

export const USE_MOCK = false;

const ENDPOINT = '/data-update';

export async function fetchDataUpdate(params = {}) {
  const res = await getNetwork().get(API_ROOT + ENDPOINT, {
    params: cleanParams(params),
  });
  return res.data;
}

function cleanParams({ result, module, from, to }) {
  const out = {};
  if (result && result !== 'all') out.result = result;
  if (module && module !== 'all') out.module = module;
  if (from) out.from = from;
  if (to) out.to = to;
  return out;
}

export default fetchDataUpdate;
